import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Field from './Field.styled';
import { RadioItemEditorContainer } from './FormRadioGroup.styled';
import { FormLegend, FormFieldset, RadioCheckboxLegendLabel } from './Form.styled';
import { getID } from '../../utils';
import { trackMe } from '../ComponentTracker/componentTracker';
import Checkbox from './FormCheckbox.styled';
import { SROnly } from '../../GlobalStyle/utilities/utilities.styled';

export const FormCheckboxGroup = ({
    id,
    name,
    legend,
    options,
    hasError,
    errorMessage,
    helpMessage,
    onChange,
    inputRef,
    className,
}) => {

    useEffect(() => {
        trackMe('FormCheckboxGroup');
    }, []);

    const genID = () => {
        return id || getID();
    };

    const elemID = genID();

    return (
        <FormFieldset
            aria-invalid={ hasError }
            className={ className }
        >
            {legend && <FormLegend>
                <RadioCheckboxLegendLabel>{legend}</RadioCheckboxLegendLabel>
                {helpMessage && (
                    <Field.GroupHelp>{helpMessage}</Field.GroupHelp>
                )}
                {hasError && errorMessage && <SROnly>{errorMessage}</SROnly>}
            </FormLegend>}
            <>
                {options.map((option, index) =>
                    <CheckboxItem key={ `${elemID}-${index}` }
                        id={ `${elemID}-${index}` }
                        name={ name }
                        option={ option }
                        onChange={ onChange }
                        hasError={ hasError }
                        inputRef={ inputRef }
                    />
                )}
            </>
            {hasError && <Field.Error aria-hidden='true'>{errorMessage}</Field.Error>}
        </FormFieldset>
    );
};

FormCheckboxGroup.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    legend: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.node.isRequired,
        })
    ).isRequired,
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string,
    helpMessage: PropTypes.string,
    onChange: PropTypes.func,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
    ]),
};

export const CheckboxItem = ({ id, name, option, onChange, hasError, inputRef }) => {
    const editor = option.isChecked && option.editor ? option.editor : undefined;

    return (
        <>
            <Checkbox.Item>
                <Checkbox.Input
                    type='checkbox'
                    id={ id }
                    className={ hasError ? 'error' : '' }
                    name={ name }
                    value={ option.value }
                    checked={ option.isChecked }
                    onChange={ onChange }
                    ref={ inputRef }
                />
                <Checkbox.Label htmlFor={ id } hasError={ hasError }>{option.label}</Checkbox.Label>
            </Checkbox.Item>
            {editor && (
                <RadioItemEditorContainer>
                    {editor}
                </RadioItemEditorContainer>
            )}
        </>
    );
};

CheckboxItem.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    hasError: PropTypes.bool,
    option: PropTypes.shape({
        editor: PropTypes.node
    }),
    value: PropTypes.any,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
    ]),
};

export default FormCheckboxGroup;
